export const InstallationGuideList = [
    { 
		code : "RAYSCAN α+ (NEW)",
        title : "RAYSCAN α+ (NEW)",
		guides : [
			{ 
				title : "1. System Overview RAYSCAN α+ (NEW)",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/96c31f5b-ff7a-41d3-8389-82b16b4e509c.pdf"
			},
			{
				title : "2. Unpacking",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/22b94d06-41f5-45a7-bdfc-d1a55c8d1249.pdf"
			},
            {
				title : "3. Floor Stand + Wall Mount",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/6987b1e5-d075-4564-8f0e-0dcc8815d248.pdf"
			},
            {
				title : "4. Floor Mount + Wall Mount",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/00caa084-cd7e-447e-ac33-65eaf87f1cbe.pdf"
			},
            {
				title : "5. Cable Connection",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/6d8f56b8-d33f-4b5d-a4c6-dc1cc67eba90.pdf"
			},
            {
				title : "6. Accessories",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/c8c0c350-a26a-41c2-9862-d79cde77ff2b.pdf"
			},
            {
				title : "Pan+CBCT (Full)",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/65e91500-d73e-4c9d-97b9-5c8760163a6e.pdf"
			}

		],
		option : [ 
			{ 
                code : "311000",
				title : "130V(CT/PX)",
                ceph : "noceph"
			},
            {
                code : "311300",
                title : "130V-OCG(CT/PX/DX)",
                ceph : "ocg"
            },
            {
                code : "311310",
                title : "130V-OCG-OCT(CT/PX/DX/OT)",
                ceph : "ocg"
            },
            {
                code : "311200",
                title : "130V-OCS(CT/PX/DX)",
                ceph : "ocs"
            },
            {
                code : "311210",
                title : "130V-OCS-OCT(CT/PX/DX/OT)",
                ceph : "ocs"
            },
            {
                code : "311010",
                title : "130V-OCT(CT/PX/OT)",
                ceph : "noceph"
            },
            {
                code : "311400",
                title : "130V-SC(CT/PX/DX)",
                ceph : "sc"
            },
            {
                code : "311410",
                title : "130V-SC-OCT(CT/PX/DX/OT)",
                ceph : "sc"
            },
            {
                code : "311100",
                title : "130V-SCS(CT/PX/DX)",	
                ceph : "scs"
            },
            {
                code : "311110",
                title : "130V-SCS-OCT(CT/PX/DX/OT)",	
                ceph : "scs"
            },
            {
                code : "321000",
                title : "160V(CT/PX)",
                ceph : "noceph"
            },
            {
                code : "321300",
                title : "160V-OCG(CT/PX/DX)",	
                ceph : "ocg"
            },
            {
                code : "321310",
                title : "160V-OCG-OCT(CT/PX/DX/OT)",	
                ceph : "ocg"
            },
            {
                code : "321200",
                title : "160V-OCS(CT/PX/DX)", 	
                ceph : "ocs"
            },
            {
                code : "321210",
                title : "160V-OCS-OCT(CT/PX/DX/OT)",	
                ceph : "ocs"
            },
            {
                code : "321010",
                title : "160V-OCT(CT/PX/OT)",	
                ceph : "noceph"
            },
            {
                code : "321400",
                title : "160V-SC(CT/PX/DX)",	
                ceph : "sc"
            },
            {
                code : "321410",
                title : "160V-SC-OCT(CT/PX/DX/OT)",	
                ceph : "sc"
            },
            {
                code : "321100",
                title : "160V-SCS(CT/PX/DX)",	
                ceph : "scs"
            },
            {
                code : "321110",
                title : "160V-SCS-OCT(CT/PX/DX/OT)", 	
                ceph : "scs"
            }
		],
        cephType : [
            {
                ceph : "ocg",
                subGuide : [
                    {
                        title : "1. System Overview ocg",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/76defdee-7b27-4b3c-ae6e-ea5489d13f13.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/24db7889-1546-4203-bd18-8e42a946cb21.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/52498bba-24bf-401f-a345-c238a9805161.pdf"
                    },
                    {
                        title : "OCG (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/2df4fe14-3236-4215-93d8-292698361e6c.pdf"
                    }
                ]
            },
            {
                ceph : "ocs",
                subGuide : [
                    {
                        title : "1. System Overview ocs",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/bb5ad998-3227-442a-9551-e69837bce479.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/192cf485-668d-4fae-826f-421d02be235b.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/0800b984-5e98-4625-ba08-6ddaa632162b.pdf"
                    },
                    {
                        title : "OCS (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/8e8f0c28-8ec8-4371-95fa-3f5631d80667.pdf"
                    }
                ]
            },
            {
                ceph : "sc",
                subGuide : [
                    {
                        title : "1. System Overview sc",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/e9a13e46-7c19-4e62-8451-bb89dae0c423.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/9fa14249-0a3e-4bf0-829f-75da574939fe.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/bdbd6c27-14a4-4392-9e05-238c12b6e396.pdf"
                    },
                    {
                        title : "SC (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/b1664409-b369-466b-8632-bb233c3563b1.pdf"
                    }
                ]
            },
            {
                ceph : "scs",
                subGuide : [
                    {
                        title : "1. System Overview scs",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/529f1925-f914-4122-9e94-86ca1bc1fce6.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/411726ef-e3e8-4ee1-80a1-f9364f0ce979.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/9c3d69f0-bd9b-46d6-bada-33ab46993834.pdf"
                    },
                    {
                        title : "SCS (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/055b8b43-31c3-4627-a881-8cf88e919376.pdf"
                    }
                ]
            },
        ]
	},
    {
        code : "RAYSCAN α+",
        title : "RAYSCAN α+",
		guides : [
			{ 
				title : "1. System Overview RAYSCAN α+",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/3bd22b5b-d684-472e-8819-a030944d5342.pdf"
			},
			{
				title : "2. Unpacking",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/37817548-0cee-4752-b320-5e37aebb6981.pdf"
			},
            {
				title : "3. Floor Stand + Wall Mount",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/01102fbf-1ebb-400a-8471-38dad7389f72.pdf"
			},
            {
				title : "4. Floor Mount + Wall Mount",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/bcf0d971-2978-4ff8-ace4-e1777c7a8408.pdf"
			},
            {
				title : "5. Cable Connection",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/23c53276-0829-4a7a-8363-896059188139.pdf"
			},
            {
				title : "6. Accessories",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/976b292f-2d5e-4ca4-a5f3-082c757917b9.pdf"
			},
            {
				title : "Pan+CBCT (Full)",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/c4450aa4-fd84-43b8-99fb-e431961d228b.pdf"
			}
		],
        option : [ 
            {
                code : "1010",
                title : "130(CT/PX)",
                ceph : "noceph"
            },
            {
                code : "1015",
                title : "130-OCG(CT/PX/DX)",	
                ceph : "ocg"
            },
            {
                code : "1013",
                title : "130-OCL(CT/PX/DX)",	
                ceph : "ocl"
            },
            {
                code : "1012",
                title : "130-OCS(CT/PX/DX)",	
                ceph : "ocs"
            },
            {
                code : "1011",
                title : "130-SC(CT/PX/DX)",	
                ceph : "sc"
            },
            {
                code : "1016",
                title : "130-SCS(CT/PX/DX)",	
                ceph : "scs"
            },
            {
                code : "1130",
                title : "160(CT/PX)",	
                ceph : "noceph"
            },
            {
                code : "1135",
                title : "160-OCG(CT/PX/DX)",	
                ceph : "ocg"
            },
            {
                code : "1133",
                title : "160-OCL(CT/PX/DX)",	
                ceph : "ocl"
            },
            {
                code : "1132",
                title : "160-OCS(CT/PX/DX)",
                ceph : "ocs"
            },
            {
                code : "1131",
                title : "160-SC(CT/PX/DX)",	
                ceph : "sc"
            },
            {
                code : "1136",
                title : "160-SCS(CT/PX/DX)",	
                ceph : "scs"
            },
            {
                code : "1210",
                title : "80(CT/PX)",
                ceph : "noceph"
            },
            {
                code : "1215",
                title : "80-OCG(CT/PX/DX)",
                ceph : "ocg"
            },
            {
                code : "1213",
                title : "80-OCL(CT/PX/DX)",	
                ceph : "ocl"
            },
            {
                code : "1212",
                title : "80-OCS(CT/PX/DX)", 
                ceph : "ocs"
            },
            {
                code : "1211",
                title : "80-SC(CT/PX/DX)",
                ceph : "sc"
            },
            {
                code : "1216",
                title : "80-SCS(CT/PX/DX)",	//1216
                ceph : "scs"
            }
        ],
        cephType : [
            {
                ceph : "ocg",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/cb8f18a9-05ff-446b-ae3f-aa1602b1b698.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/8a4829c7-63e6-4ff4-8f7c-83ba4290b1f3.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/50d83c64-5a97-4c3e-a00f-ef82e08cf0a2.pdf"
                    },
                    {
                        title : "OCG (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/8fa0e75e-7b6e-4b3d-8c4e-85a725fd9f05.pdf"
                    }
                ]
            },
            {
                ceph : "ocl",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/26317837-eb09-495d-bc68-1b9152a144a0.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/58616ffe-5743-4071-81bb-3c19928ef5c6.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/2348abf0-e27b-4ba9-b10a-1fe2ed8bd101.pdf"
                    },
                    {
                        title : "OCL (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/d85a2e46-c4c5-4537-8426-7d87f782c584.pdf"
                    }
                ]
            },
            {
                ceph : "ocs",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/0757d5d0-b5f9-4342-8847-d4f8ace2a25e.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/d1264125-3c6c-45db-a2b8-bfc3d23e7592.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/1fb857c4-bcff-404c-aefc-38645c830328.pdf"
                    },
                    {
                        title : "OCS (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/b9094924-8892-4919-9256-920a2c0c0882.pdf"
                    }
                ]
            },
            {
                ceph : "sc",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/1daef75b-f42d-40f1-8e45-4ee6d2268276.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/9aedf9a1-fe7e-44ce-a78b-b5b9e91c0daa.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/bd926eec-60d6-4bb8-aa9d-8787d92e53e5.pdf"
                    },
                    {
                        title : "SC (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/1edcd51c-afc2-4c8b-835a-b16dd5a7b473.pdf"
                    }
                ]
            },
            {
                ceph : "scs",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/a190634c-ecef-4f5b-b899-932b9715ff48.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/0ba3b4ef-384e-418a-a03b-c891f301c37d.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/00489d21-8e47-4aeb-9e11-439c17cdd5c7.pdf"
                    },
                    {
                        title : "SCS (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/89453d69-e465-4731-be2a-e2d5a8c396ea.pdf"
                    }
                ]
            },
        ]
    },
    {
        code : "RAYSCAN α 2DN",
        title : "RAYSCAN α 2DN",
		guides : [
            {}
		],
        option : [ 
            {
                code : "502300",
                title : "LOCG",	
                ceph : "OCG"
            },
            {
                code : "502500",
                title : "LOCSO",	
                ceph : "ocso"
            },
            {
                code : "502000",
                title : "LPP", 	
                ceph : "noceph"
            },
            {
                code : "502100",
                title : "LSCS",	
                ceph : "scs"
            }
        ],
        cephType : [{}]
    },
    {
        code : "RAYSCAN α (NEW) 3D",
        title : "RAYSCAN α (NEW) 3D",
		guides : [
			{ 
				title : "1. System Overview",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/47b07b6a-6347-4a06-aaaa-cab5861f08ce.pdf"
			},
			{
				title : "2. Unpacking",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/2e5ed1a9-f7c0-4849-a397-1f50faa020b0.pdf"
			},
            {
				title : "3. Floor Stand + Wall Mount",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/2422d538-d3f3-4a6b-afb5-92c24ba7780a.pdf"
			},
            {
				title : "4. Floor Mount + Wall Mount",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/20575d98-556f-4ffa-9abf-44f7d85556ea.pdf"
			},
            {
				title : "5. Cable Connection",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/ce9a6557-b1f0-438a-ac84-f8b0a62f6676.pdf"
			},
            {
				title : "6. Accessories",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/c7b84cd3-84d2-4879-958c-23a92b7e4a22.pdf"
			},
            {
				title : "Pan+CBCT (Full)",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/9262449d-5973-480e-81a1-e5f5e22e0ee8.pdf"
			}
		],
        option : [
            {
                code : "511000",
                title : "100V(CT/PX)",
                ceph : "noceph"
            },
            {
                code : "511300",
                title : "100V-OCG(CT/PX/DX)",	
                ceph : "ocg"
            },
            {
                code : "511310",
                title : "100V-OCG-OCT(CT/PX/DX/OCT)",	
                ceph : "ocg"
            },
            {
                code : "511200",
                title : "100V-OCS(CT/PX/DX)",	
                ceph : "ocs"
            },
            {
                code : "511210",
                title : "100V-OCS-OCT(CT/PX/DX/OCT)",	
                ceph : "ocs"
            },
            {
                code : "511010",
                title : "100V-OCT(CT/PX/OCT)",	
                ceph : "noceph"
            },
            {
                code : "511400",
                title : "100V-SC(CT/PX/DX)",
                ceph : "sc"
            },
            {
                code : "511410",
                title : "100V-SC-OCT(CT/PX/DX/OCT)",
                ceph : "sc"
            },
            {
                code : "511100",
                title : "100V-SCS(CT/PX/DX)",
                ceph : "scs"
            },
            {
                code : "511110",
                title : "100V-SCS-OCT(CT/PX/DX/OCT)",	
                ceph : "scs"
            }
        ],
        cephType : [
            {
                ceph : "ocg",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/b93f5c3b-324d-4d82-a573-d132dbb199b3.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/eee03ccd-5345-425b-a736-b882f5853760.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/76953872-bddc-4184-b521-50a1212bbd2f.pdf"
                    },
                    {
                        title : "OCG (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/7cb76991-6a82-4c45-9919-7e6aefaabe8f.pdf"
                    }
                ]
            },
            {
                ceph : "ocs",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/fb920b05-377d-4292-98d6-265439b0c785.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/a697f67f-3fdf-48b2-b095-df1c760e6f56.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/6f0e6668-b63b-48f7-bb45-4cea3ec6c0e9.pdf"
                    },
                    {
                        title : "OCS (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/e909ad19-d76c-44bf-8692-962d4733a9ea.pdf"
                    }
                ]
            },
            {
                ceph : "sc",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/2870caf0-69fc-420f-90c1-cf386924a5dd.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/497819ca-2cd7-45c3-b923-6489990861ee.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/0009cd66-0bb6-4e99-8f6d-b9586bc03e9c.pdf"
                    },
                    {
                        title : "SC (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/162a4b9e-f693-44d5-bc87-1717e952a020.pdf"
                    }
                ]
            },
            {
                ceph : "scs",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/d1c2750d-c58f-4cca-91ce-3b0e58b473f9.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/b5212509-93a0-46e2-b17e-6837bdb25905.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/8c6c0bc3-047b-466b-b1e4-6bef6ca5ccab.pdf"
                    },
                    {
                        title : "SCS (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/aad0ddce-9dbf-4ed4-a655-920352094ec1.pdf"
                    }
                ]
            },
        ]
    },
    {
        code : "RAYSCAN α (NEW) 2D",
        title : "RAYSCAN α (NEW) 2D",
		guides : [
			{ 
				title : "1. System Overview",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/9503e83a-539e-43d2-9cc5-7d2d077ebba6.pdf"
			},
			{
				title : "2. Unpacking",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/12a0bbdc-663d-46bc-9874-f616961934b4.pdf"
			},
            {
				title : "3. Floor Stand + Wall Mount",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/27cb16ec-5671-47ae-81e6-e6b9336c2897.pdf"
			},
            {
				title : "4. Floor Mount + Wall Mount",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/e5b1a489-d8b4-45ae-8701-a26cfea041fa.pdf"
			},
            {
				title : "5. Cable Connection",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/1dd70b8c-77ed-44af-ae76-17e505fe2db0.pdf"
			},
            {
				title : "6. Accessories",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/48e65e3f-e3d1-48f0-9633-262b052bcab5.pdf"
			},
            {
				title : "Pan (Full)",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/db4baafd-2871-43c6-8f4c-4571343a91c1.pdf"
			}
		],
        option : [
            {
                code : "20",
                title : "LOCG",	//20
                ceph : "ocg"
            },
            {
                code : "19",
                title : "LOCS",	//19
                ceph : "ocs"
            },
            {
                code : "17",
                title : "LPP",	    //17
                ceph : "noceph"
            },
            {
                code : "21",
                title : "LSC", 	//21
                ceph : "sc"
            },
            {
                code : "18",
                title : "LSCS",	//18
                ceph : "scs"
            }
        ],
        cephType : [
            {
                ceph : "ocg",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/a7dcef08-8981-48f7-9f1e-3c220df274c1.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/5cc6ca21-f464-4a4c-b996-2673579cb44b.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/8df11a2e-777a-40c9-8915-51a2935f4636.pdf"
                    },
                    {
                        title : "OCG (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/f7360743-1153-4643-b912-454e48f4c82a.pdf"
                    }
                ]
            },
            {
                ceph : "ocs",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/e4276992-299f-4e04-a234-97d9b286d177.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/11802969-e8c9-4ef8-a0ce-d62f04945696.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/e6736f13-c16e-4ed0-a4c5-85e6279e04cb.pdf"
                    },
                    {
                        title : "OCS (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/09095518-ce49-4a6b-9566-4a9988ef9296.pdf"
                    }
                ]
            },
            {
                ceph : "sc",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/81840102-1875-4a35-b286-b11ce7c20963.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/5c80797a-3be6-4dee-b6f1-7d7d08045ca5.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/7938b6dd-8e33-4000-9adf-bd63c3c7cc1b.pdf"
                    },
                    {
                        title : "SC (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/322c87de-a061-4363-b284-762cddb24eaf.pdf"
                    }
                ]
            },
            {
                ceph : "scs",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/fb0685ec-6e11-4bb3-977e-528bdd92c646.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/655fc1f6-3183-4eea-a462-349f59dd77ed.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/7a620eb5-4b7e-4e35-a608-30bf1ca88608.pdf"
                    },
                    {
                        title : "SCS (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/6d81bacc-8a0d-4f2c-8fe1-88c6401f0863.pdf"
                    }
                ]
            },
        ]
    },
    {
        code : "RAYSCAN Studio",
        title : "RAYSCAN Studio",
		guides : [
			{ 
				title : "1. System Overview",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/0f8bf2bd-e768-4f2f-867a-2a42fecedc87.pdf"
			},
			{
				title : "2. Unpacking",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/bee4d9e9-5abb-4a8f-a269-21e14108f590.pdf"
			},
            {
				title : "3. Floor Stand + Wall Mount",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/b073c593-dfea-4f1d-9441-0c829c4324c8.pdf"
			},
            {
				title : "4. Floor Mount + Wall Mount",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/ed466d57-46c6-4ee7-8da9-1569e043a396.pdf"
			},
            {
				title : "5. Cable Connection",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/6f8e51f4-f7eb-4fd2-83f5-4b5a83bc991b.pdf"
			},
            {
				title : "6. Accessories",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/d53a5f1f-90af-435d-9fbe-810e17faa820.pdf"
			},
            {
				title : "Pan+CBCT (Full)",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/001445b7-ee6f-43be-9490-c7e5c6a69cb2.pdf"
			}
		],
        option : [
            {
                code : "399000",
                title : "200V(CT/PX)",
                ceph : "noceph"
            },
            {
                code : "399300",
                title : "200V-OCG(CT/PX/DX)",
                ceph : "ocg"
            },
            {
                code : "399390",
                title : "200V-OCG-OCT(CT/PX/DX/OT)",
                ceph : "ocg"
            },
            {
                code : "399200",
                title : "200V-OCS(CT/PX/DX)",
                ceph : "ocs"
            },
            {
                code : "399290",
                title : "200V-OCS-OCT(CT/PX/DX/OT)",
                ceph : "ocs"
            },
            {
                code : "399090",
                title : "200V-OCT(CT/PX/OT)",
                ceph : "noceph"
            },
            {
                code : "399100",
                title : "200V-SCS(CT/PX/DX)",
                ceph : "scs"
            },
            {
                code : "399190",
                title : "200V-SCS-OCT(CT/PX/DX/OT)",
                ceph : "scs"
            }
        ],
        cephType : [
            {
                ceph : "ocg",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/889b0bd0-1a6f-4445-a9ac-eb873f6e4b87.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/f2d6ec4d-8dee-4407-906e-3f43791d4393.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/95d01f54-7e46-45bd-b4ff-2a9a5a5d2dd6.pdf"
                    },
                    {
                        title : "OCG (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/5d61817b-81dc-4e7d-a1c3-82a6800cffb5.pdf"
                    }
                ]
            },
            {
                ceph : "ocs",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/813873c7-4f86-42ae-9a2b-172ad6524761.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/b4d9d20b-4845-403d-bdbf-5d70c72eff8d.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/910f7e63-0fb9-4e7d-b675-1aaf8a78b231.pdf"
                    },
                    {
                        title : "OCS (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/a6907c5d-da13-47ce-91ce-caca1da9e1f1.pdf"
                    }
                ]
            },
            {
                ceph : "scs",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/81d7874e-b1d2-4f75-9515-ee6d05e89316.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/83819094-4ffd-47e5-a276-477b1457125d.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/02f6c062-2327-4a97-9414-2150af294122.pdf"
                    },
                    {
                        title : "SCS (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/07261e6e-8da0-4340-b86c-16025306808e.pdf"
                    }
                ]
            },
        ]
    },
    {
        code : "RAYSCAN m+ (New)",
        title : "RAYSCAN m+ (New)",
        guides : [
			{ 
				title : "1. System Overview",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/17d6eacf-fea3-4956-948a-19a1ac70ce80.pdf"
			},
			{
				title : "2. Unpacking",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/abc560e9-7ec1-48e6-9659-05ef75adb6f6.pdf"
			},
            {
				title : "3. Floor Stand + Wall Mount",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/f7837043-516a-4f24-a8b1-11783e784f1a.pdf"
			},
            {
				title : "4. Floor Mount + Wall Mount",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/3a67459c-8de9-4579-9b8c-ba2786681703.pdf"
			},
            {
				title : "5. Cable Connection",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/eb8c0975-b83d-4faa-ae83-f855e1757ac9.pdf"
			},
            {
				title : "6. Accessories",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/0f4b43e6-4686-4c08-8dc1-84bf33ebb862.pdf"
			},
            {
				title : "Pan+CBCT (Full)",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/811566fd-f251-49c7-bca8-3a00fa8468d2.pdf"
			}
		],
        option : [
            {
                code : "710000",
                title : "160(ENT CT)",
                ceph : "noceph"
            },
            {
                code : "710400",
                title : "160-DRSC(ENT CT/DX)",
                ceph : "sc"
            },
            {
                code : "710100",
                title : "160-DRSCS(ENT CT/DX)",
                ceph : "scs"
            },
            {
                code : "710200",
                title : "160-DRSG(ENT CT)",
                ceph : "noceph"
            },
            {
                code : "710300",
                title : "160-SDR(ENT CT/SDR)",
            }
        ],
        cephType : [
            {
                ceph : "dr",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/b32d3732-3c9b-4b19-bc7f-222e551719da.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/262490e0-9167-4ca8-ad1b-2cae8caca08f.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/8c542b1f-6cbc-4345-ad75-5b80d7b0a6a8.pdf"
                    },
                    {
                        title : "DR (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/10528b92-5c26-455a-9bdf-3bdd492143c7.pdf"
                    }
                ]
            },
            {
                ceph : "sc",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/7fbf6869-35ec-47a9-8aa5-03bbfe217814.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/2ac93e73-908b-4404-96e6-ee490adf8838.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/041bd3a0-b1ec-492e-b1dd-a43acc9f536a.pdf"
                    },
                    {
                        title : "SC (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/7e15fb59-484c-4e08-92dd-69f4c49325d0.pdf"
                    }
                ]
            },
            {
                ceph : "scs",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/48730f8a-d464-4561-993f-562fe7334f84.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/cea7d4d9-f354-46b2-ac99-399d72e17dd1.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/b801c918-be3e-40ea-8896-a117f154bf40.pdf"
                    },
                    {
                        title : "SCS (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/69a428c7-c690-4a4e-a974-ab55b18a0a37.pdf"
                    }
                ]
            }
        ]
    },
    {
        code : "RAYSCAN m+",
        title : "RAYSCAN m+",
        guides : [
			{ 
				title : "1. System Overview",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/e2e03032-f32d-4543-8419-1671c7c18ce9.pdf"
			},
			{
				title : "2. Unpacking",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/0bfc15ae-80e9-4693-a5ba-a70b9f9fb608.pdf"
			},
            {
				title : "3. Floor Stand + Wall Mount",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/08c10755-f208-4b48-b469-cfd0f0b098c4.pdf"
			},
            {
				title : "4. Floor Mount + Wall Mount",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/3aaec679-7e00-49c7-a3d8-ab21dfe88484.pdf"
			},
            {
				title : "5. Cable Connection",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/11f0b78e-11fa-4941-bd9d-7eb37f56e6e8.pdf"
			},
            {
				title : "6. Accessories",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/b7663fb1-1934-45e7-84df-dc7b54825788.pdf"
			},
            {
				title : "Pan+CBCT (Full)",
				path : "https://rayguard.blob.core.windows.net/rayguard-contents/96c5f787-1639-4ba0-bf8d-8950dc05bde1.pdf"
			}
		],
        option : [
            {
                code : "3000",
                title : "160(ENT CT)",
                ceph : "noceph"
            },
            {
                code : "3002",
                title : "160-DR(ENT CT/DR)",
                ceph : "dr"
            },
            {
                code : "3001",
                title : "160-SC(ENT CT/DX)",
                ceph : "sc"
            },
            {
                code : "3003",
                title : "160-SDR(ENT CT/SDR)",
                ceph : "noceph"
            }
        ],
        cephType : [
            {
                ceph : "dr",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/2fd3ae8e-756b-4dc5-af38-a077d1f0383a.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/95618c19-2530-49e6-ac78-1c83c6074146.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/2542da5f-10ed-4a35-9179-df5301628cd5.pdf"
                    },
                    {
                        title : "DR (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/b68b666d-141b-4db2-9235-bc743a174b48.pdf"
                    }
                ]
            },
            {
                ceph : "sc",
                subGuide : [
                    {
                        title : "1. System Overview",
				        path : "https://rayguard.blob.core.windows.net/rayguard-contents/a4b241f1-b06f-448d-a3f5-9f4f52709852.pdf"
                    },
                    {
                        title : "2. Unpacking",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/770b3d68-1986-4c86-a8ed-ee9573a19cd5.pdf"
                    },
                    {
                        title : "3. Assembly",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/6e1e9a94-f14e-451d-97e9-8c685c7795da.pdf"
                    },
                    {
                        title : "SC (Full)",
                        path : "https://rayguard.blob.core.windows.net/rayguard-contents/abc7fe8c-c450-46f1-92a5-809b007b5a63.pdf"
                    }
                ]
            }
        ]
    }
]